// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"790":"2fad2594","934":"fba4c33e"}[chunkId] + ".chunk.js";
};